import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import TextEditor from "../../Components/Inputs/TextEditor";

export default function ({register, errors, control, data, watch}) {
  return (
    <>
      <ReactSelectInput
        label="Choose page category"
        name="category"
        className="my-5"
        required={true}
        options={data?.categories}
        errorMessage={errors?.category}
        control={control}
      />
      <TextInput
        label="Name"
        name="name"
        register={register}
        required={true}
        errorMessage={errors?.name}
      />

      <TextInput
        label="Slug"
        name="slug"
        register={register}
        required={true}
        errorMessage={errors?.slug}
      />

      <TextEditor
        control={control}
        name="content"
        label="Content"
        errorMessage={errors?.content}
      />
    </>
  );
}